export default __webpack_public_path__ + "static/media/Gold_award.68e710a8.png";